import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  _idCentroCostoNivel1: Yup.string().min(3).max(500).required(),
  _idCentroCostoNivel2: Yup.string().min(3).max(500).required()
})

const ActualizarCentroCostoModal = ({ handleClose, show, modalData, actualizarFilaHandler }) => {
  const formInitialValues = React.useMemo(
    () => ({
      _idCentroCostoNivel1: modalData._idCentroCostoNivel1 || '',
      _idCentroCostoNivel2: modalData._idCentroCostoNivel2 || '',
      centroCostoNivel2Info: modalData.centroCostoNivel2Info || ''
    }),
    [modalData]
  )

  const submitHandler = async data => {
    actualizarFilaHandler({
      ...modalData,
      ...data
    })
    handleClose()
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>ACTUALIZAR CENTRO COSTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CentroCostoNivel1FormGroup
                fIsSubmitting={isSubmitting}
                iError={errors._idCentroCostoNivel1}
                iTouched={touched._idCentroCostoNivel1}
                setFieldValue={setFieldValue}
              />
              {values._idCentroCostoNivel1 && (
                <FormGroups.CentroCostoNivel2FormGroup
                  setFieldValue={setFieldValue}
                  iValue={values.centroCostoNivel2Info}
                  idNodoPadre={values._idCentroCostoNivel1}
                />
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button onClick={handleSubmit}>Actualizar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ActualizarCentroCostoModal)
